import { render } from "./ShareActionSheet.vue?vue&type=template&id=873a1be2"
import script from "./ShareActionSheet.vue?vue&type=script&lang=js"
export * from "./ShareActionSheet.vue?vue&type=script&lang=js"
script.render = render

export default script